import { u3204ResolveConversationDisplayTitle } from './u3204ResolveConversationDisplayTitle';

export type U3204ConversationHeaderInput = {
  isNewChat: boolean;
  selectedMissionId: string | null;
  missionTitle: string | null;
  conversationTitle: string | null;
  placeholderLabel: string;
};

/**
 * Libellé en-tête zone conversation (BL-0155 #7, BL-0163 placeholder).
 */
export function u3204BuildConversationHeaderLabel(input: U3204ConversationHeaderInput): string | null {
  const missionTitle = input.missionTitle?.trim() ?? '';
  const conversationTitle = u3204ResolveConversationDisplayTitle(
    input.conversationTitle,
    input.placeholderLabel,
  );

  if (input.isNewChat) {
    return input.selectedMissionId ? missionTitle || null : null;
  }

  if (!input.selectedMissionId) {
    return missionTitle ? `${missionTitle} — ${conversationTitle}` : conversationTitle;
  }

  return conversationTitle;
}
